import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-phone-input-2/lib/style.css';

import './assets/scss/index.scss';
import Routes from './routes';
import store from './store/store';
import { ContainerToast } from './components/Toast/Toast';
import { SharedStateProvider } from './StoreContext';
import MaintenancePage from './components/MaintenancePage'; // Import Maintenance Page

const App = () => {
  const isMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

  return (
    <Provider store={store}>
      <SharedStateProvider>
        <div id='portal' />
        {isMaintenance ? (
          <MaintenancePage />
        ) : (
          <Router>
            <Routes />
          </Router>
        )}
      </SharedStateProvider>
      <ContainerToast />
    </Provider>
  );
};

export default App;
